import { useTranslation } from 'react-i18next'
import { common, expanders } from '@ocean/ui'
import { DetailsSectionWrapper } from 'layouts/details'
import { namespace } from 'modules/simulatorTrainings/common/localization'
import { SectionArguments } from 'modules/simulatorTrainings/common/types/productSheet'
import { Content } from './About.styled'

const { Expander } = expanders
const { HTMLContent, SectionTitle, Spacer } = common

const I18_PATH = `${namespace}:simulatorTraining.productSheet.about`

type AboutProps = {
  description?: string
  sectionArguments?: SectionArguments | null
}

const About: React.FC<AboutProps> = ({ description, sectionArguments }) => {
  const { t } = useTranslation()

  function renderContent(description: string) {
    if (sectionArguments?.expanded === '1')
      return <HTMLContent content={description} typographyVariant='p' />
    return <Expander text={description} rows={3} dataTest='AboutText' />
  }

  if (!description) return null

  return (
    <DetailsSectionWrapper>
      <SectionTitle title={t(`${I18_PATH}.title`)} dataTest='AboutTitle' />
      <Content>{renderContent(description)}</Content>
      <Spacer size='huge' />
    </DetailsSectionWrapper>
  )
}

export default About
